<template>
  <div class="px-6 py-2.5 flex justify-end">
    <div class="items-center flex gap-4">
      <div class="items-center flex gap-2">
        <Switch
          class="flex"
          :size="!maxSmall ? 'sm' : 'md'"
          :checked="createMore"
          @update:checked="emit('update:create-more', $event)"
        />
        <div class="text-sm font-medium">
          {{ t("components.asset_create.create_more") }}
        </div>
      </div>
      <Button
        :size="!maxSmall ? 'sm' : 'lg'"
        @click="emit('submit')"
        :disabled="!form.name"
        :loading="isLoading"
      >
        {{ t("components.asset_create.title") }}
      </Button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { Switch } from "@/SharedComponents/Switchers";
import { Button } from "@/SharedComponents/Buttons";
import { useBreakpoints } from "@/Composables/useBreakpoints";

// Translations
const { t } = useI18n();

// Breakpoints
const { maxSmall } = useBreakpoints();

// Define Emits
const emit = defineEmits(["update:create-more", "submit"]);

// Define Props
defineProps({
  createMore: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  form: { type: Object, required: true },
});
</script>
